/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, {useRef, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {
    MotifDropdown, MotifButton, MotifIcon, MotifCheckbox, MotifBadge
} from '@ey-xd/motif-react';
import {actionIcShoppingCart24px, navigationIcClose24px, socialIcPersonAdd24px, avIcFiberNew24px} from '@ey-xd/motif-react/assets/icons';
import {useDispatch, useSelector} from 'react-redux';
import {CART_COMPARE_DATA, CART_OPEN} from '../../constants/reducerTypes';
import content from '../../constants/content';
import './CartAndComparePopup.scss';
import AppConfig from "../../app_config/appConfig";
import AdobeEventRegister from '../../app_config/adobeEventRegister';
import whatsNewPageData from '../../store/actions/whatsNewAction';
import UtilityService from "../../providers/utilityService";

const CartAndComparePopup = () => {
    const wrapperRef = useRef(null);
    const dispatch = useDispatch();
    const history = useHistory();
    // const checkCurrentComponent = useSelector(state => state.isHomeComponentReducer);
    const whatsNewData = useSelector(state => state.whatsNewData);
    const generalConfig = useSelector(state => state.generalData.configuration);
    const cartCompareConfig = generalConfig && generalConfig.CartComparisonPageConfiguration;
    const [compareDisabled, setCompareDisabled] = useState(true);
    const [deactivateStoreUpdate, setDeactivateStoreUpdate] = useState(false);
    const generalData = useSelector(state => state.generalData);
    const isCartOpen = !!((generalData && generalData.isCartOpen));
    const [cartItems, setCartItems] = useState((generalData && generalData.cartItems) ? [...generalData.cartItems] : []);
    const checkCurrentComponent = useSelector(state => state.isHomeComponentReducer);

    /**
   * enable compare button if any of the cart item selected
   * enable/disable checkbox based on selection count
   *
   */
    const checkCompareEnable = () => {
        if (cartItems && Array.isArray(cartItems) && cartItems.length > 0) {
            const selectedCartItems = cartItems.filter(cartItem => cartItem.selected === true);
            let disableNonSelectedFields = false;
            // disable checkbox selection if 4 items selected already
            if (cartCompareConfig && selectedCartItems.length >= cartCompareConfig.compareLimit) {
                disableNonSelectedFields = true;
            }
            setCartItems(cartItems.map(addedItem => {
                const itemObj = addedItem;
                itemObj.disabled = !itemObj.selected ? disableNonSelectedFields : false;
                return itemObj;
            }));
            setCompareDisabled(selectedCartItems.length <= 0);
        }
        else {
            setCompareDisabled(true);
        }
    };

    /**
   * handle click outside and close drpdown.
   *
   */
    const setClickOutsideCart = (event) => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {
            dispatch({
                type: CART_OPEN,
                payload: false
            });
            // unregister outside click handler
            document.removeEventListener("mousedown", setClickOutsideCart);
        }
    };
    /**
   * update popup open state
   *
   */
    const openOrCloseCartPopup = (status) => {
        dispatch({
            type: CART_OPEN,
            payload: status
        });
        if (status) {
            // register outside click handler
            document.addEventListener("mousedown", setClickOutsideCart);
            UtilityService.adobeCommonScript(AdobeEventRegister.cartCompare.compareIconClick.eventName,
                AdobeEventRegister.cartCompare.cartIconClick.clickedItem,
                AdobeEventRegister.cartCompare.cartIconClick.componentlinkIdentifier,
                "", "", "", "", "", "", "", `${window.location.origin}/#${AppConfig.routePaths.compare}`);
        } else {
            // unregister outside click handler
            document.removeEventListener("mousedown", setClickOutsideCart);
        }
    };

    /**
   * handle close button click of dropdown.
   *
   */
    const setClickClose = () => {
        openOrCloseCartPopup(false);
    };


    /**
  * handle toggle drpdown.
  */
    const handleToggleCart = () => {
        openOrCloseCartPopup(!isCartOpen);
        checkCompareEnable();
    };

    /**
   * handle click compare selected items.
   *
   */
    const handleCompare = () => {
        UtilityService.adobeCommonScript(AdobeEventRegister.cartCompare.compareIconClick.eventName,
            AdobeEventRegister.cartCompare.compareIconClick.clickedItem,
            AdobeEventRegister.cartCompare.compareIconClick.componentlinkIdentifier,
            "", "", "", "", "", "", "", `${window.location.origin}/#${AppConfig.routePaths.compare}`);
        dispatch({
            type: CART_COMPARE_DATA,
            payload: cartItems
        });
        openOrCloseCartPopup(false);
        history.push({
            pathname: AppConfig.routePaths.compare
        });
    };

    /**
     * handle click what's new.
     *
     */
    const handleWhatsNew = () => {
        UtilityService.adobeCommonScript(AdobeEventRegister.whatsNew.linkClick.eventName, AdobeEventRegister.whatsNew.title, AdobeEventRegister.whatsNew.linkClick.componentlinkIdentifier, "", "", "", "", "", "", "", `${window.location.origin}/#${AppConfig.routePaths.whatsNew}`);
        history.push({
            pathname: AppConfig.routePaths.whatsNew,
        });
    };

    /**
     * handle click what's new announcement.
     *
     */
    const handleWhatsNewAnnouncement = () => {
        history.push({
            pathname: AppConfig.routePaths.whatsNew,
        });
    };

    /**
     * handle click new joiner.
     *
     */
    const handleNewJoiner = () => {
        UtilityService.adobeCommonScript(AdobeEventRegister.newJoiner.linkClick.eventName, AdobeEventRegister.newJoiner.title, AdobeEventRegister.newJoiner.linkClick.componentlinkIdentifier, "", "", "", "", "", "", "", `${window.location.origin}/#${AppConfig.routePaths.newJoiner}`);
        history.push({
            pathname: AppConfig.routePaths.newJoiner,
        });
    };

    /**
   * handle click clear all cart items.
   *
   */
    const handleClearAll = () => {
        if (cartItems && Array.isArray(cartItems) && cartItems.length > 0) {
            const clearSelectionCartItems = cartItems.map(cartItem => {
                return {
                    ...cartItem,
                    disabled: false,
                    selected: false
                }
            });
            setCartItems(clearSelectionCartItems);
            dispatch({
                type: CART_COMPARE_DATA,
                payload: clearSelectionCartItems
            });
        }
        setCompareDisabled(true);
    };

    /**
   * handle click item and make selected items add and clear based on action.
   * Release 29.5: Added composite filter key
   */
    const removeSelectItem = (item, event) => {
        const cartItemCopy = generalData && generalData.cartItems;
        const cartLocalStateCopy = cartItems;
        if (item && item.id && cartItemCopy && Array.isArray(cartItemCopy) && cartItemCopy.length > 0) {
            const storeIndexFound = cartItemCopy.findIndex(cartItem => item.id === cartItem.id && item.path === cartItem.path);
            if (storeIndexFound >= 0) {
                cartItemCopy.splice(storeIndexFound, 1);
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                }
                if (cartLocalStateCopy && Array.isArray(cartLocalStateCopy) && cartLocalStateCopy.length > 0) {
                    cartLocalStateCopy.splice(cartLocalStateCopy.findIndex(localCartItem => item.id === localCartItem.id && item.path === localCartItem.path), 1);
                }
                checkCompareEnable();
                setDeactivateStoreUpdate(true);
                setCartItems(cartLocalStateCopy);
                dispatch({
                    type: CART_COMPARE_DATA,
                    payload: cartItemCopy
                });
            }
        }
    };

    /**
   * handle click item and make selected items add and clear based on action.
   * Release 29.5: Added composite filter key
   */
    const handleSelectItem = (item) => {
        const cartItemCopy = cartItems;
        if (item && item.id && cartItemCopy && Array.isArray(cartItemCopy) && cartItemCopy.length > 0) {
            const storeIndexFound = cartItemCopy.findIndex(cartItem => item.id === cartItem.id && item.path === cartItem.path);
            if (storeIndexFound >= 0) {
                cartItemCopy[storeIndexFound] = {...item, selected: !item.selected};
                setCartItems(cartItemCopy);
            }
            checkCompareEnable();
        }
    };

    useEffect(() => {
        // checking the compare button enable if any item selected
        checkCompareEnable();
        dispatch(whatsNewPageData());
    }, []);

    useEffect(() => {
        if (generalData && generalData.cartItems && !deactivateStoreUpdate) {
            setCartItems([...generalData.cartItems]);
        }
        setDeactivateStoreUpdate(false);
    }, [generalData]);


    useEffect(() => {
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", setClickOutsideCart);
        };
    }, [wrapperRef]);

    return (
        <>
            {/* {checkCurrentComponent._isHomeComponent ? */}
            <div ref={wrapperRef} className="motif-container cart-compare">
                <MotifButton type="button" onClick={handleNewJoiner} className="top-nav-button newjoiner-button" aria-label="cart and compare dropdown" title="A collection of most popular assets by category">
                    <MotifIcon src={socialIcPersonAdd24px} />
                    <span className='icon-label'>{content.newJoiner.title}</span>
                </MotifButton>
                <div className="whatsnew-container">
                    <div className={(whatsNewData && whatsNewData.length > 0  && checkCurrentComponent._isHomeComponent ? (whatsNewData[0].announce ? "whatsnew-button announcement-button" : "whatsnew-button") : "whatsnew-button")}>
                        <MotifButton type="button" onClick={handleWhatsNew} className="top-nav-button" title="A record of functionality and content changes">
                            <MotifIcon src={avIcFiberNew24px} />
                            
                            <span className='icon-label'>{content.whatsNew.title}</span>
                        </MotifButton>
                    </div>
                    
                    {whatsNewData && whatsNewData.length ? (
                        whatsNewData[0].announce &&
                        <div className="whatsnew-announcement" style={{width: `${whatsNewData[0].announce.length * 7}px`, marginLeft: `-${whatsNewData[0].announce.length * 7 > 260 ? 130 : whatsNewData[0].announce.length * 3.5}px`}}>
                            {checkCurrentComponent._isHomeComponent ?
                            <div className="whatsnew-announcement-arrow">
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M5 8L0.5 8L8.5 -4.51408e-06L16.5 7.99999L14 8L5 8Z" fill="#FFE600" />
                                </svg>
                            </div>:null}
                            {checkCurrentComponent._isHomeComponent ?
                            <div onClick={handleWhatsNewAnnouncement} title={whatsNewData[0].announceTooltip} className="whatsnew-announcement-text">{whatsNewData[0].announce}</div>:null}
                        </div>
                    ) : null
                    }
                </div>
                {checkCurrentComponent._isHomeComponent ?
                <MotifDropdown
               
                    className="cart-button-container"
                    open={isCartOpen}
                    placement="bottom-right"
                    aria-labelledby="cart and compare"
                    
                    trigger={
                        <MotifButton
                            title="Side-by-side comparison of data assets"
                            type="button"
                            onClick={handleToggleCart}
                            aria-expanded={isCartOpen}
                            className="cart-button"
                            aria-label="cart and compare dropdown"
                        >
                            <MotifIcon className={(cartItems && cartItems.length > 0) ? 'motif-icon cart-not-empty' : 'motif-icon'} src={actionIcShoppingCart24px} />
                            {(Array.isArray(cartItems) && cartItems && cartItems.length > 0) ?
                                (<MotifBadge value={cartItems.length} overlap />) :
                                ''
                            }
                            
                            <span className='icon-label'>{content.viewCart.title}</span>
                        </MotifButton>

                    }
                   
                > 
                    <div className="header-container">
                        <div className="label-palceholder-content">
                            <div className="label-container">
                                {content.cartAndComparePopup.label}
                            </div>
                        </div>
                        <MotifButton
                            type="button"
                            className="close-button"
                            aria-label="close view cart button"
                            onClick={setClickClose}
                        >
                            <MotifIcon src={navigationIcClose24px} />
                        </MotifButton>
                    </div>
                    <div className="body-container">
                        <div className="item-container">
                            {(Array.isArray(cartItems) && cartItems && cartItems.length > 0) ? (
                                <div>
                                    {cartItems.map(cartItem => (
                                        <div className="cart-list"
                                            title={cartItem.disabled ? "You can only select up to 4 items" : ""}
                                            key={cartItem.path}>
                                            <MotifCheckbox
                                                id={cartItem.path}
                                                className="check-box-list-item"
                                                value={cartItem.id}
                                                name={`cart-item-${cartItem.id}`}
                                                checked={cartItem.selected}
                                                disabled={cartItem.disabled}
                                                onChange={() => handleSelectItem(cartItem)}
                                            >
                                                <span className="item-label" title={cartItem.title}>{cartItem.title}</span>


                                            </MotifCheckbox>
                                            <MotifButton
                                                type="button"
                                                className="item-close-btn"
                                                title="Remove compare items from cart"
                                                aria-label="remove compare items from cart"
                                                onClick={event => removeSelectItem(cartItem, event)}
                                            >
                                                <MotifIcon src={navigationIcClose24px} />
                                            </MotifButton>
                                        </div>
                                    ))}
                                </div>
                            ) : <div className="empty-cart-message">{content.cartAndComparePopup.emptyMessage}</div>}

                        </div>
                    </div>

                    <div className="footer-container-dropdown">
                        <MotifButton
                            type="button"
                            className="cart-compare-button"
                            onClick={handleCompare}
                            aria-label="Compare"
                            disabled={compareDisabled}
                        > {content.cartAndComparePopup.compareBtnLabel}
                        </MotifButton>
                        {(Array.isArray(cartItems) && cartItems && cartItems.length > 0) ? (
                            <MotifButton
                                type="button"
                                className="cart-clear-button"
                                onClick={handleClearAll}
                                aria-label="Clear"
                                disabled={compareDisabled}
                            > {content.cartAndComparePopup.clearAllBtnLabel}
                            </MotifButton>
                        ) : null}
                    </div>
                    
                </MotifDropdown>
                :null}
            </div>
            {/* : null} */}
        </>
    )
}

export default CartAndComparePopup;
